/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'

const AuthLayout = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  // Open modal
  const openModal = () => {
    console.log('Opening modal') // Add log to check
    setIsModalOpen(true)
  } // Close modal
  const closeModal = () => setIsModalOpen(false)

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  const PrivacyPolicyModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null

    return (
      <div
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1050, // Ensure the modal appears above other content
        }}
        onClick={onClose} // Close modal when clicking outside
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '80%',
            maxWidth: '800px',
            zIndex: 1060, // Modal content above overlay
            maxHeight: '80vh', // Set max height to 80% of the viewport height
            overflowY: 'auto', // Allow scrolling if content exceeds max height
            position: 'relative', // To contain the inner elements
          }}
          onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicked inside
        >
          <h2 style={{ textAlign: 'center' }}>Terms</h2>© {new Date().getFullYear().toString()} ASM
          Global LLP. All Rights Reserved. <br />
          <strong>INCLUSIV</strong> is the exclusive property of CONSULERE ASM Global LLP. The
          content, design, features, and functionality of the Inclusiv App, including but not
          limited to all software, code, text, graphics, logos, images, and data compilations, are
          protected by international copyright laws and other intellectual property rights.
          Unauthorized reproduction, distribution, modification, or use of any part of the Inclusiv
          App without the prior written consent of ASM Global LLP is strictly prohibited and may
          result in legal action. <br />
          For permissions, inquiries, or further information, please contact: <br />
          ASM Global LLP <br />
          Unit No 702, Mehrauli Gurgaon Industrial Park <br />
          Gurugram, Haryana <br />
          India <br />
          Email: info@asmglobal.co.in <br />
          Phone: +918092085778 <br />
          <br />
          TERMS OF SERVICE THIS IS AN AGREEMENT BETWEEN YOU OR THE ENTITY THAT YOU REPRESENT
          (HEREINAFTER “YOU” or “YOUR”) AND CONSULERE ASM GLOBAL LLP (HEREINAFTER “ASM”) GOVERNING
          YOUR USE OF ASM ONLINE TRACK & TRACE, CREDIT GENERATION AND RECYCLING SOFTWARE PLATFORM{' '}
          <br />
          <br />
          Parts of this Agreement <br />
          <br />
          This Agreement consists of the following terms and conditions (hereinafter the “General
          Terms”) and terms and conditions, if any, specific to use of individual Services
          (hereinafter the “Service Specific Terms”). In the event of a conflict between the General
          Terms and Service Specific Terms, the Service Specific Terms shall prevail. <br />
          <br />
          Acceptance of the Agreement <br />
          <br />
          You must be of legal age to enter into a binding agreement in order to accept the
          Agreement. If you do not agree to the General Terms, do not use any of our Services. If
          you agree to the General Terms and do not agree to any Service Specific Terms, do not use
          the corresponding Service. You can accept the Agreement by checking a checkbox or clicking
          on a button indicating your acceptance of the Agreement or by actually using the Services.{' '}
          <br />
          Description of Service <br />
          We provide cloud software and applications for businesses, including associated offline
          and mobile applications("Service" or "Services"). You may use the Services for your
          personal and business use or for internal business purpose in the organization that you
          represent. You may connect to the Services using any Internet browser supported by the
          Services. You are responsible for obtaining access to the Internet and the equipment
          necessary to use the Services. You can create and edit content with your user account and
          if you choose to do so, you can publish and share such content. Beta Service <br />
          We may offer certain Services as closed or open beta services ("Beta Service" or “Beta
          Services”) for the purpose of testing and evaluation. You agree that we have the sole
          authority and discretion to determine the period of time for testing and evaluation of
          Beta Services. We will be the sole judge of the success of such testing and the decision,
          if any, to offer the Beta Services as commercial services. You will be under no obligation
          to acquire a subscription to use any paid Service as a result of your subscription to any
          Beta Service. We reserve the right to fully or partially discontinue, at any time and from
          time to time, temporarily or permanently, any of the Beta Services with or without notice
          to you. You agree that ASM will not be liable to you or to any third party for any harm
          related to, arising out of, or caused by the modification, suspension or discontinuance of
          any of the Beta Services for any reason. <br />
          <br />
          User Sign up Obligations <br />
          <br />
          You need to sign up for a user account by providing all required information in order to
          access or use the Services. If you represent an organization and wish to use the Services
          for corporate internal use, we recommend that you, and all other users from your
          organization, sign up for user accounts by providing your corporate contact information.
          In particular, we recommend that you use your corporate email address. You agree to:{' '}
          <br /> (i) provide true, accurate, current and complete information about yourself as
          prompted by the sign up process; and <br /> (ii) maintain and promptly update the
          information provided during sign up to keep it true, accurate, current, and complete. If
          you provide any information that is untrue, inaccurate, outdated, or incomplete, or if ASM
          has reasonable grounds to suspect that such information is untrue, inaccurate, outdated,
          or incomplete, ASM may terminate your user account and refuse current or future use of any
          or all of the Services. Restrictions on Use In addition to all other terms and conditions
          of this Agreement, you shall not: <br /> (i) transfer the Services or otherwise make it
          available to any third party; <br />
          (ii) provide any service based on the Services without prior written permission; <br />{' '}
          (iii) allow user licenses to be shared or used by more than one individual other than by
          way of reassigning the user license to a new user; <br /> (iv) except as permitted under
          applicable law, attempt to disassemble, reverse engineer or decompile the Services; <br />
          (v) use third party links to sites without agreeing to their website terms & conditions;{' '}
          <br />
          (vi) post links to third party sites or use their logo, company name, etc. without their
          prior written permission; <br />
          (vii) attempt to gain unauthorized access to the Services or its related systems or
          network; <br />
          (viii) use the Services in any manner that could damage, disable, overburden, impair or
          harm any server, network, computer system, resource of ASM; <br /> (ix) use the Services
          to send or store material containing software viruses, worms or other harmful computer
          codes, files, scripts or programs; <br />
          (x) use the Services in any manner that interferes with or disrupts the integrity,
          security or performance of the Services, its components and the data contained therein;{' '}
          <br />
          (xi) create a false identity to mislead any person as to the identity or origin of any
          communication; <br />
          (xii) host, display, upload, modify, publish, transmit, store, update or share any
          information that belongs to another person or entity and to which you do not have any
          right, including personal or confidential information of any person or entity with respect
          to which you do not have consent or permission from such person or entity; <br />
          (xiii) use the Services for transmitting information that is false and untrue, and is
          written or published in any form, with the intent to mislead or harass a person, entity or
          agency for financial gain or to cause any injury to any person; <br />
          (xiv) violate any applicable local, state, national or international law; <br />
          (xv) use the Services for any form of competitive or benchmarking purposes; and <br />
          (xvi) remove or obscure any proprietary or other notices contained in the Services.
          <br />
          <br />
          Spamming and Illegal Activities <br />
          <br />
          You agree to be solely responsible for the contents of your transmissions through the
          Services. You agree not to use the Services for illegal purposes or for the transmission
          of material that is unlawful, defamatory, harassing, libelous, invasive of another's
          privacy, abusive, threatening, harmful, vulgar, pornographic, obscene, or is otherwise
          objectionable, offends religious sentiments, promotes racism, contains viruses or
          malicious code, or that which infringes or may infringe intellectual property or other
          rights of another. You agree not to use the Services for the transmission of "junk mail",
          "spam", "chain letters", “phishing” or unsolicited mass distribution of email. We reserve
          the right to terminate your access to the Services if there are reasonable grounds to
          believe that you have used the Services for any illegal or unauthorized activity. <br />
          <br />
          Third Party Applications <br />
          <br />
          ASM Services integrate with many third party applications (hereinafter "Third Party
          Application(s)"). Access and use of the Third Party Applications may require acceptance of
          terms of service and privacy policies applicable to such Third Party Applications
          (hereinafter "Third Party Terms"). You are responsible for reading and understanding the
          Third Party Terms before accessing or using any Third Party Application. You acknowledge
          and agree that ASM is not liable for any Third Party Applications. While we will try to
          provide you with advance notice, whenever reasonably possible, you acknowledge and agree
          that ASM may, at any time and in our sole discretion, and without any notice to you,
          suspend, restrict or disable access to or remove from ASM Services, any Third Party
          Application, without any liability to you, including without limitation for any loss of
          profits, revenue, data, goodwill or other intangible losses. <br />
          <br />
          Fees and Payments <br />
          <br />
          The Services are available under subscription plans, pay per use plans, one-time payment
          plans of various durations. Payments for subscription plans of duration of less than a
          year can be made only by Credit Card. Your subscription will be automatically renewed at
          the end of each subscription period unless you downgrade your paid subscription plan to a
          free plan or inform us that you do not wish to renew the subscription. At the time of
          automatic renewal, the subscription fee will be charged to the Credit Card last used by
          you. We provide you the option of changing the details if you would like the payment for
          the renewal to be made through a different Credit Card. If you do not wish to renew the
          subscription, you must inform us at least seven days prior to the renewal date. If you
          have not downgraded to a free plan and if you have not informed us that you do not wish to
          renew the subscription, you will be presumed to have authorized ASM to to charge the
          subscription fee to the Credit Card last used by you. <br />
          From time to time, we may change the price of any Service or charge for use of Services
          that are currently available free of charge. Any increase in charges will not apply until
          the expiry of your then current billing cycle. You will not be charged for using any
          Service unless you have opted for a paid subscription plan. <br />
          In the event any tax such as GST, VAT, sales tax or the like is chargeable by ASM in
          accordance with any local, state, provincial or foreign laws with respect to your
          subscription to our Services ("Taxes"), ASM will invoice you for such Taxes. You agree to
          pay ASM such Taxes in addition to the subscription fees. ASM shall provide you with an
          invoice in the format prescribed by the applicable local, state, provincial or foreign
          laws to help you avail the applicable input tax credit for the Taxes so paid. <br />
          <br />
          Organization Accounts and Administrators <br />
          <br />
          When you sign up for an account for your organization you may specify one or more
          administrators. The administrators will have the right to configure the Services based on
          your requirements and manage end users in your organization account. If your organization
          account is created and configured on your behalf by a third party, it is likely that such
          third party has assumed administrator role for your organization. Make sure that you enter
          into a suitable agreement with such third party specifying such party’s roles and
          restrictions as an administrator of your organization account. <br />
          You are responsible for <br />
          (i) ensuring confidentiality of your organization account password, <br />
          (ii) appointing competent individuals as administrators for managing your organization
          account, and <br />
          (iii) ensuring that all activities that occur in connection with your organization account
          comply with this Agreement. You understand that ASM is not responsible for account
          administration and internal management of the Services for you. <br />
          You are responsible for taking necessary steps for ensuring that your organization does
          not lose control of the administrator accounts. You may specify a process to be followed
          for recovering control in the event of such loss of control of the administrator accounts
          by sending an email to info@asmglobal.co.in, provided that the process is acceptable to
          ASM. In the absence of any specified administrator account recovery process, ASM may
          provide control of an administrator account to an individual providing proof satisfactory
          to ASM demonstrating authorization to act on behalf of the organization. You agree not to
          hold ASM liable for the consequences of any action taken by ASM in good faith in this
          regard. <br />
          <br />
          Personal Information and Privacy <br />
          <br />
          Personal information you provide to ASM through the Service is governed by ASM Privacy
          Policy. Your election to use the Service indicates your acceptance of the terms of the ASM
          Privacy Policy. You are responsible for maintaining confidentiality of your username,
          password and other sensitive information. You are responsible for all activities that
          occur in your user account and you agree to inform us immediately of any unauthorized use
          of your user account by email to accounts@asmglobal.co.in or by calling us on any of the
          numbers listed on www.asmglobal.co.in We are not responsible for any loss or damage to you
          or to any third party incurred as a result of any unauthorized access and/or use of your
          user account, or otherwise. <br />
          <br />
          Communications from ASM <br />
          <br />
          The Service may include certain communications from ASM, such as service announcements,
          administrative messages and newsletters. You understand that these communications shall be
          considered part of using the Services. As part of our policy to provide you total privacy,
          we also provide you the option of opting out from receiving newsletters from us. However,
          you will not be able to opt-out from receiving service announcements and administrative
          messages. <br />
          <br />
          Complaints <br />
          <br />
          If we receive a complaint from any person with respect to your activities as part of use
          of the Services, we will forward the complaint to the primary email address of your user
          account. You must respond to the complainant directly within 10 days of receiving the
          complaint forwarded by us and copy ASM in the communication. If you do not respond to the
          complainant within 10 days from the date of our email to you, we may disclose your name
          and contact information to the complainant for enabling the complainant to take legal
          action against you. You understand that your failure to respond to the forwarded complaint
          within the 10 days’ time limit will be construed as your consent to disclosure of your
          name and contact information by ASM to the complainant. <br />
          <br />
          Inactive User Accounts Policy
          <br />
          <br /> We reserve the right to terminate unpaid user accounts that are inactive for a
          continuous period of 120 days. In the event of such termination, all data associated with
          such user account will be deleted. We will provide you prior notice of such termination
          and option to back-up your data. The data deletion policy may be implemented with respect
          to any or all of the Services. Each Service will be considered an independent and separate
          service for the purpose of calculating the period of inactivity. In other words, activity
          in one of the Services is not sufficient to keep your user account in another Service
          active. In case of accounts with more than one user, if at least one of the users is
          active, the account will not be considered inactive. <br />
          <br />
          Data Ownership <br />
          <br />
          We respect your right to ownership of content created or stored by you. You own the
          content created or stored by you. Unless specifically permitted by you, your use of the
          Services does not grant ASM the license to use, reproduce, adapt, modify, publish or
          distribute the content created by you or stored in your user account for ASM’s commercial,
          marketing or any similar purpose. But you grant ASM permission to access, copy,
          distribute, store, transmit, reformat, publicly display and publicly perform the content
          of your user account solely as required for the purpose of providing the Services to you.{' '}
          <br />
          <br />
          Hosting Location <br />
          <br />
          The location of the cloud facility from which you are served depends on the mapping of
          your region/country to the available cloud facilities at the time of your sign-up. We may
          migrate your account or require you to migrate your account to a different cloud facility
          in the event of any updates to the region/country to cloud facility mapping at any point
          of time. You must not mask your internet protocol (IP) address at the time of sign-up
          since your region/country is determined base on your IP address. If, at any time, your
          actual region/country is found to be different from the region/country in our records, ASM
          may take appropriate action such as migrate your account or require you to migrate your
          account to the cloud facility corresponding to your region/country, or close your account
          and deny the Service to you. If you are served from a cloud facility outside your
          region/country and a ASM group entity has an office in your region/country, apart from
          storing the data in the cloud facility assigned to you, we may store a local copy of the
          data in your region/country.
          <br />
          <br /> User Generated Content <br />
          <br />
          You may transmit or publish content created by you using any of the Services or otherwise.
          However, you shall be solely responsible for such content and the consequences of its
          transmission or publication. Any content made public will be publicly accessible through
          the internet and may be crawled and indexed by search engines. You are responsible for
          ensuring that you do not accidentally make any private content publicly available. Any
          content that you may receive from other users of the Services, is provided to you AS IS
          for your information and personal use only and you agree not to use, copy, reproduce,
          distribute, transmit, broadcast, display, sell, license or otherwise exploit such content
          for any purpose, without the express written consent of the person who owns the rights to
          such content. In the course of using any of the Services, if you come across any content
          with copyright notice(s) or any copy protection feature(s), you agree not to remove such
          copyright notice(s) or disable such copy protection feature(s) as the case may be. By
          making any copyrighted/copyrightable content available on any of the Services you affirm
          that you have the consent, authorization or permission, as the case may be from every
          person who may claim any rights in such content to make such content available in such
          manner. Further, by making any content available in the manner aforementioned, you
          expressly agree that ASM will have the right to block access to or remove such content
          made available by you if ASM receives complaints concerning any illegality or infringement
          of third party rights in such content. By using any of the Services and transmitting or
          publishing any content using such Service, you expressly consent to determination of
          questions of illegality or infringement of third party rights in such content by the agent
          designated by ASM for this purpose. <br />
          <br />
          Sample files and Applications <br /> <br />
          ASM may provide sample files and applications for the purpose of demonstrating the
          possibility of using the Services effectively for specific purposes. The information
          contained in any such sample files and applications consists of random data. ASM makes no
          warranty, either express or implied, as to the accuracy, usefulness, completeness or
          reliability of the information or the sample files and applications. <br />
          <br />
          Trademark <br />
          <br />
          'ASM', ASM logo, the names of individual Services and their logos are trademarks of
          Consuelere ASM Global LLP. You agree not to display or use, in any manner, the ASM
          trademarks, without ASM’s prior permission. <br />
          <br />
          Disclaimer of Warranties <br />
          <br />
          YOU EXPRESSLY UNDERSTAND AND AGREE THAT THE USE OF THE SERVICES IS AT YOUR SOLE RISK. THE
          SERVICES ARE PROVIDED ON AN AS-IS-AND-AS-AVAILABLE BASIS. ASM EXPRESSLY DISCLAIMS ALL
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE
          IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. ASM MAKES NO
          WARRANTY THAT THE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE. USE OF
          ANY MATERIAL DOWNLOADED OR OBTAINED THROUGH THE USE OF THE SERVICES SHALL BE AT YOUR OWN
          DISCRETION AND RISK AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER
          SYSTEM, MOBILE TELEPHONE, WIRELESS DEVICE OR DATA THAT RESULTS FROM THE USE OF THE
          SERVICES OR THE DOWNLOAD OF ANY SUCH MATERIAL. NO ADVICE OR INFORMATION, WHETHER WRITTEN
          OR ORAL, OBTAINED BY YOU FROM ASM, ITS EMPLOYEES OR REPRESENTATIVES SHALL CREATE ANY
          WARRANTY NOT EXPRESSLY STATED IN THE AGREEMENT. <br />
          <br />
          Limitation of Liability <br />
          <br />
          YOU AGREE THAT ASM SHALL, IN NO EVENT, BE LIABLE FOR ANY CONSEQUENTIAL, INCIDENTAL,
          INDIRECT, SPECIAL, PUNITIVE, OR OTHER LOSS OR DAMAGE WHATSOEVER OR FOR LOSS OF BUSINESS
          PROFITS, BUSINESS INTERRUPTION, COMPUTER FAILURE, LOSS OF BUSINESS INFORMATION, OR OTHER
          LOSS ARISING OUT OF OR CAUSED BY YOUR USE OF OR INABILITY TO USE THE SERVICE, EVEN IF ASM
          HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. IN NO EVENT SHALL ASM’S ENTIRE
          LIABILITY TO YOU IN RESPECT OF ANY SERVICE, WHETHER DIRECT OR INDIRECT, EXCEED ONE
          THOUSAND DOLLARS ($1000) OR THE FEES PAID BY YOU DURING THE TWELVE (12) MONTHS PRIOR TO
          THE FIRST EVENT GIVING RISE TO SUCH LIABILITY, WHICHEVER IS HIGHER. <br />
          <br />
          Indemnification <br />
          <br />
          You agree to indemnify and hold harmless ASM, its officers, directors, employees,
          suppliers, and affiliates, from and against any losses, damages, fines and expenses
          (including attorney's fees and costs) arising out of or relating to any claims that you
          have used the Services in violation of another party's rights, in violation of any law, in
          violations of any provisions of the Agreement, or any other claim related to your use of
          the Services, except where such use is authorized by ASM.
          <br />
          <br /> Governing Law and Jurisdiction <br />
          <br />
          The governing law and jurisdiction that will apply in case of any dispute or lawsuit
          arising out of or in connection with this Agreement, will depend on your billing address
          if you are a paid customer and your state or country of domicile in all other cases.
          Accordingly, each party agrees to the governing law (without regard to choice or conflicts
          of law rules) and to the exclusive jurisdiction of the courts in case of any dispute or
          lawsuit arising out of or in connection with this Agreement . <br />
          <br />
          Suspension and Termination <br />
          <br />
          We may suspend your user account or temporarily disable access to whole or part of any
          Service in the event of any suspected illegal activity, extended periods of inactivity or
          requests by law enforcement or other government agencies. Objections to suspension or
          disabling of user accounts should be made to info@asmglobal.co.in within thirty days of
          being notified about the suspension. We may terminate a suspended or disabled user account
          after thirty days. We will also terminate your user account on your request. <br />
          In addition, we reserve the right to terminate your user account and deny the Services
          upon reasonable belief that you have violated the Agreement and to terminate your access
          to any Beta Service in case of unexpected technical issues or discontinuation of the Beta
          Service. You have the right to terminate your user account if ASM breaches its obligations
          under this Agreement and in such event, you will be entitled to prorated refund of any
          prepaid fees. Termination of user account will include denial of access to all Services,
          deletion of information in your user account such as your email address and password and
          deletion of all data in your user account.
          <br />
          <br /> Modification of Terms of Service <br />
          <br />
          We may modify this Agreement upon notice to you at any time through a service announcement
          or by sending email to your primary email address. If we make significant changes to the
          Agreement that affect your rights, you will be provided with at least 30 days advance
          notice of the changes by email to your primary email address. You may terminate your use
          of the Services by providing ASM notice by email within 30 days of being notified of the
          availability of the modified Agreement if the Agreement is modified in a manner that
          substantially affects your rights in connection with use of the Services. In the event of
          such termination, you will be entitled to prorated refund of the unused portion of any
          prepaid fees. Your continued use of the Service after the effective date of any change to
          the Agreement will be deemed to be your agreement to the modified Agreement. End Of Terms
          Of Service <br />
          If you have any questions or concerns regarding this Agreement, please contact us at
          info@asmglobal.co.in <br />
          PRIVACY POLICY <br />
          REFER THE VERSION WE HAVE IN WEBSITE <br />
          LOCATION POLICY <br />
          Location Information Policy <br />
          Effective Date: [Date] <br />
          Last Updated: [Date] <br />
          1. Introduction This Location Information Policy explains how Inclusiv (“the App”),
          developed by CONSULERE ASM Global LLP (“we,” “us,” “our”), collects, uses, stores, and
          shares location information obtained from users (“you,” “your”) of the App. We are
          committed to protecting your privacy and ensuring the security of your data. <br />
          2. Collection of Location Information <br />
          Purpose: The App may collect your location information to provide specific features and
          services, such as identifying nearby events, optimizing routes, or delivering
          location-based content. Type of Data Collected: The App may collect precise geographic
          location data (e.g., GPS coordinates) and approximate location data (e.g., derived from IP
          address). <br />
          Consent: Location information is collected only with your explicit consent. You can choose
          to enable or disable location services through your device settings at any time. <br />
          3. Use of Location Information <br />
          Service Enhancement: We use location data to enhance your user experience by providing
          relevant services based on your current location. <br />
          Analytics: Location data may be used in an aggregated and anonymized manner to analyze
          usage patterns and improve the App’s functionality and content. Compliance: We may use
          your location data to comply with legal obligations or respond to lawful requests from
          public authorities. <br />
          4. Sharing of Location Information <br />
          Third-Party Services: We may share your location data with trusted third-party service
          providers who assist us in delivering location-based features. These providers are
          contractually obligated to protect your data and use it only for the purposes we specify.
          Legal Requirements: We may disclose your location information if required by law or in
          response to legal processes, such as court orders or subpoenas. <br />
          5. Data Security <br />
          We implement appropriate technical and organizational measures to protect your location
          data from unauthorized access, disclosure, alteration, or destruction. However, no method
          of transmission over the Internet or method of electronic storage is completely secure. 6.
          Your Choices <br />
          Opt-Out: You can opt-out of location data collection by adjusting your device’s location
          settings. Please note that disabling location services may limit certain functionalities
          of the App. Data Access: You have the right to request access to the location data we have
          collected about you and request its correction or deletion, subject to legal and
          contractual restrictions. <br />
          7. Changes to This Policy We may update this Location Information Policy from time to time
          to reflect changes in our practices or legal requirements. We will notify you of any
          significant changes through the App or other communication channels. <br />
          8. Contact Us <br />
          If you have any questions or concerns about this Location Information Policy, please
          contact us at: ASM Global LLP <br />
          Email: info@asmglobal.co.in <br />
          Phone: +918092085778 <br />
          Software License Policy <br />
          Effective Date: 30 Oct 2024 <br />
          Last Updated: 01 Jan 2025 <br />
          1. Introduction <br />
          This Software License Policy (“Policy”) governs the use of the Inclusiv (“the App”),
          developed and owned by CONSULERE ASM Global LLP (“we,” “us,” “our”). By downloading,
          installing, or using the App, you (“user,” “you,” “your”) agree to comply with and be
          bound by this Policy. If you do not agree to these terms, you may not use the App. <br />
          2. Grant of License <br />
          License Type: We grant you a non-exclusive, non-transferable, revocable, and limited
          license to download, install, and use the App on your device(s) for personal or internal
          business purposes only, subject to the terms and conditions of this Policy. <br />
          License Scope: The license granted is limited to the use of the App in accordance with the
          functionalities as provided by us. You may not use the App for any purpose other than that
          for which it is intended. <br />
          3. Restrictions on Use <br />
          Prohibited Activities: You may not: <br />
          Modify, adapt, translate, reverse-engineer, decompile, disassemble, or create derivative
          works based on the App. <br />
          Rent, lease, lend, sell, redistribute, or sublicense the App. <br />
          Use the App in any unlawful manner, for any unlawful purpose, or in any manner
          inconsistent with this Policy. Access or attempt to access the source code of the App.
          Compliance: You must comply with all applicable laws and regulations in your use of the
          App.
          <br /> 4. Intellectual Property Rights Ownership: The App, including all associated
          intellectual property rights, is and shall remain the exclusive property of CONSULERE ASM
          Global LLP. This Policy does not grant you any rights to trademarks, service marks, logos,
          or other proprietary information related to the App. Copyright: All content, including but
          not limited to software, code, text, images, and graphics, within the App is protected by
          copyright laws. Unauthorized use or reproduction of any content is strictly prohibited.{' '}
          <br />
          5. Updates and Upgrades <br />
          Modifications: We may, from time to time, provide updates, upgrades, or modifications to
          the App to improve performance, enhance features, or address security concerns. These
          updates may be automatically installed without prior notice. <br />
          License Extension: The terms of this Policy will govern any updates or upgrades provided
          unless such updates or upgrades are accompanied by a separate license agreement, in which
          case the terms of that license agreement will apply. <br />
          6. Termination <br />
          Termination by You: You may terminate this license at any time by uninstalling the App
          from your device(s).
          <br />
          Termination by Us: We may terminate this license at any time if you fail to comply with
          any terms of this Policy. Upon termination, you must cease all use of the App and delete
          all copies of the App from your device(s).
          <br />
          7. Disclaimer of Warranties
          <br />
          No Warranty: The App is provided “as is” and “as available,” without any warranties of any
          kind, express or implied. We do not warrant that the App will meet your requirements,
          operate without interruption, or be error-free.
          <br />
          Limitation of Liability: To the fullest extent permitted by law, ASM Global LLP shall not
          be liable for any direct, indirect, incidental, consequential, or punitive damages arising
          out of your use of the App.
          <br />
          8. Governing Law
          <br />
          This Policy shall be governed by and construed in accordance with the laws of [Your
          Jurisdiction], without regard to its conflict of law principles. <br />
          9. Changes to This Policy <br />
          We may update this Software License Policy from time to time to reflect changes in our
          practices or legal requirements. Any changes will be posted within the App or communicated
          through other means. 10. Contact Information <br />
          If you have any questions or concerns about this Software License Policy, please contact
          us at: ASM Global LLP <br />
          Email: info@asmglobal.co.in <br />
          Phone: +918092085778 <br />
          <button
            style={{
              backgroundColor: '#0057B8',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
            onClick={onClose} // Close modal when button clicked
          >
            Close
          </button>
        </div>
      </div>
    )
  }


  const [authData, setAuthData] = useState<any>(null)

  // Add this useEffect to watch for localStorage changes
  useEffect(() => {
    const updateAuthData = () => {
      try {
        const auth = JSON.parse(localStorage.getItem('auth') || '{}')
        setAuthData(auth)
      } catch {
        setAuthData(null)
      }
    }

    // Initial load
    updateAuthData()

    // Listen for storage changes (when localStorage is modified)
    window.addEventListener('storage', updateAuthData)

    // Custom event listener for same-tab localStorage changes
    window.addEventListener('localStorageChange', updateAuthData)

    return () => {
      window.removeEventListener('storage', updateAuthData)
      window.removeEventListener('localStorageChange', updateAuthData)
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* begin::Body */}
      <div
        className='d-flex flex-column w-lg-40 p-10 order-1 order-lg-1'
        style={{ background: 'black', minHeight: '100vh', justifyContent: 'space-between' }}
      >
        {/* begin::Logo */}
        <div className='d-flex  mb-1' style={{ minWidth: '480px', margin: '0 auto' }}>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/FTS Logo for home page.png')}
            style={{
              height: '40px',
              width: 'auto'
            }}
          />
        </div>
        {/* end::Logo */}

        {/* begin::Form */}
        <div className='d-flex flex-column  flex-grow-1 justify-content-center align-items-center'>
          <div style={{ minWidth: '300px', marginBottom: "10px" }}>
            {
              authData?.data?.userName ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '0px' }}>
                  <img
                    src={authData?.data?.profileImage || '/dummy.jpg'}
                    alt='Profile'
                    style={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      marginBottom: '16px',
                      objectFit: 'cover',
                    }}
                    onError={(e) => {
                      e.currentTarget.src = '/dummy.jpg'
                    }}
                  />
                  <div style={{ fontSize: '26px', color: 'white' }}>
                    Welcome back, <strong>{authData?.data?.userName?.trim()}</strong>
                  </div>
                </div>
              ) : (
                <div style={{ fontSize: '32px', marginBottom: '0px', color: 'white', textAlign: "left" }}>
                  Welcome back
                </div>
              )
            }
          </div>
          {/* begin::Wrapper */}
          <div style={{ width: '100%', maxWidth: '300px' }}>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap, flex-column gap-6'>
          {/* begin::Links */}
          <div style={{ textAlign: 'center' }}>
            <h1 className='text-white fw-bolder mb-2'>Download the app</h1>
            <div style={{ display: 'inline-block', padding: '12px', background: '#000000', borderRadius: '14px', lineHeight: 0 }}>
              <QRCodeSVG
                value={`${window.location.origin}/app-redirect`}
                size={60}
                bgColor='#000000'
                fgColor='#FFFFFF'
                level='M'
              />
            </div>
            {/* <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px', marginTop: '10px', marginBottom: 0 }}>
              Scan to download • auto-detects your device
            </p> */}
          </div>
          <div className='d-flex fw-semibold text-white fs-base'>
            <a href='https://www.freethesea.com' className='px-2 text-white' target='_blank' rel='noreferrer'>
              Copyright &copy; {new Date().getFullYear().toString()} Free The Sea
            </a>

            <a href='#'
              className='px-2 text-white'
              onClick={openModal}
            >
              Privacy policy
            </a>

            <a href='https://www.freethesea.com/contact-10'
              className='px-2 text-white'
              target='_blank'
              rel='noreferrer'
            >
              Contact Us
            </a>
          </div>
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      {/* <div
        className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        style={{ backgroundImage: `url(${toAbsoluteUrl('/media/logos/loginimg.jpg')})` }}
      ></div> */}



      <div
        className='d-flex flex-lg-row-fluid w-lg-60 order-1 order-lg-2'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/logos/loginimgv3.jpeg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      ></div>


      {/* end::Aside */}
      <PrivacyPolicyModal isOpen={isModalOpen} onClose={closeModal} />
    </div >
  )
}

export { AuthLayout }
